import React from 'react';
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import {
	getLabelColorByStateAndDifficulty,
	getTrackColorByStateAndDifficulty,
	renderLabelHelper
} from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => renderLabelHelper(coords, color, onLabelClick, '8D', 'Track8DBlue', "9.41845703");

const Track8DBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track8DBlue" transform="translate(1904.000000, 611.000000)" className="track">
		<g id="line" transform="translate(0.000000, 0.609312)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}>
			<path
				d="M14,50.3711662 L6.14603666,42.0744581 C2.4013023,38.118625 1.30674157,32.3426092 3.34455249,27.290978 C5.07528824,23.0005708 9.95638904,20.9255471 14.2467963,22.6562829 C14.4152544,22.7242383 14.5814577,22.7976553 14.7451423,22.8764173 L64.1916235,46.6691569 C70.468321,49.6893886 78.0049711,47.0495015 81.0252028,40.772804 C82.5801638,37.5412573 82.6859061,33.8005556 81.3159813,30.4863281 C80.2973805,28.0220504 81.4693331,25.1986195 83.9336108,24.1800187 C85.9053755,23.3649964 88.1783099,23.9408016 89.5242163,25.5962934 L93.9174022,31 L93.9174022,31 L97.1814018,35.1991415"/>

			<TrackArrow
				transform="translate(95.971572, 33.593772) rotate(-134.000000) translate(-95.971572, -33.593772) "
				points="99.9715718 41.5937724 91.9715718 33.5937724 99.9715718 25.5937724"
			/>

			<path
				d="M104.34991,44.861616 L133.816913,84.0142591 C135.79376,86.640885 137.184571,89.6607665 137.895606,92.8703643 L145.578928,127.55273 L145.578928,127.55273"/>
		</g>

		{renderLabel("104.474750, 52.609312", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("173.474750, 134.609312", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("13.474750, 4.609312", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
	</g>

);

Track8DBlue.propTypes = trackPropTypes;

export default Track8DBlue;
